<template>
<div class="TableEducation">
  <v-data-table
    :headers="headers"
    :items="allMaterials"
    class="px-5 services-table"
    :loading="loading.load"
    loading-text="Загрузка... Пожалуйста подождите"
    :mobile-breakpoint="300"
    :page="1"
    :items-per-page="10"
    :height="tableHeight"
    fixed-header
    hide-default-footer
  >
    <template v-slot:item.notes="{ item }">
      <v-text-field
        label="Комментарий"  class="font-sm"
        dense
        hide-details
        outlined
      />
    </template>
    <template v-slot:item.status="{ item }">
      <div class="badge font-xs " :class="materialStatusBadgeClass(item)">
        {{ item.status_display }}
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="background_transparent"
        small
        color="white"
        outlined
        @click="actionButton(item)"
      >
        {{educationStatusActionButton(item)}}
      </v-btn>
    </template>

    <template v-slot:item.created_at="{ item }">
      <div class="d-flex justify-space-between align-center">
        {{ $moment(item.created_at).format('DD.MM.YYYY') }}
      </div>
    </template>
    <template v-slot:item.toolbar="{ item }">
      <v-btn
        v-if="item.status === 'published'"
        small
        class="background_transparent no-border"
        @click="goToMaterial(item)"
      >
        <img src="@/assets/images/profile/arrowGo.svg" />

      </v-btn>
      <v-btn
        small
        class="background_transparent no-border"
        @click="goToEdit(item)"
      >
        <v-icon >mdi-pencil-outline</v-icon>

      </v-btn>
      <v-btn
        small
        class="background_transparent no-border"
        @click="$emit('deleteItem',item)"
      >
        <v-icon class="cursor-pointer">mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      Материалов не найдено.
    </template>

    <template v-slot:footer="{ props }">
      <v-data-footer
        :pagination="props.pagination"
        :options="props.options"
        items-per-page-text="Материлов на странице:"
        :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
        :page-text="`Всего материалов: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
        show-current-page
        show-first-last-page
      />
    </template>
  </v-data-table>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Компонент: TableEducation
 * Описание:
 */
export default {
  name: 'TableEducation',
  components: {},
  emits: ['publishedEducation', 'draftedEducation', 'editItem', 'deleteItem', 'goToMaterial'],
  data: () => ({
    tableHeight: 400,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: '',
        value: 'check',
        sortable: false,
        width: '60px',
      },
      {
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '90px',
        sortable: true,
      },
      {
        text: 'Заголовок',
        value: 'title',
        width: '180px',
      },
      {
        text: 'Категория',
        value: 'category_display',
        width: '190px',
        sortable: false,

      },
      {
        text: 'Дата добавления',
        align: 'center',
        value: 'created_at',
        width: '150px',
        sortable: false,
      },
      {
        text: 'Статус',
        align: 'start',
        value: 'status',
        width: '150px',
      },
      {
        text: 'Действия',
        align: 'start',
        value: 'actions',
        width: '220px',
      },
      {
        text: 'Комментарий',
        align: 'start',
        value: 'notes',
        width: '220px',
      },
      {
        text: '',
        align: 'start',
        value: 'toolbar',
        width: '220px',
      },
    ],
    paginationData: null,
  }),
  computed: {
    ...mapGetters({
      loading: 'services/services/GET_LOADING_SERVICES',
      allMaterials: 'education/Education/allMaterials',
    }),

  },
  watch: {
  },
  methods: {
    materialStatusBadgeClass(item) {
      switch (item.status) {
        case 'draft':
          return 'badge-draft';
        case 'published':
          return 'badge-published';
        default:
          return 'd-none';
      }
    },
    educationStatusActionButton(education) {
      switch (education.status) {
        case 'draft':
          return 'Опубликовать';
        case 'published':
          return 'Скрыть';
        default:
          return 'd-none';
      }
    },
    goToEdit(education) {
      this.$emit('editItem', education);
    },
    onPublishedService(education) {
      this.$emit('publishedEducation', education, true);
    },
    onDraftedService(education) {
      this.$emit('draftedEducation', education, false);
    },
    actionButton(education) {
      switch (education.status) {
        case 'draft':
          this.onPublishedService(education);
          break;
        case 'published':
          this.onDraftedService(education);
          break;
        default: {
          return false;
        }
      }
    },
    goToMaterial(education) {
      this.$emit('goToMaterial', education);
    }
  },
  created() {
  },
  mounted() {
    const height = document.documentElement.clientHeight - 270;
    this.tableHeight = Math.max(height, this.tableHeight);
  },
};
</script>

<style scoped lang="scss">
.TableEducation {
  & thead{
    background: red;
  }
  & .v-btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    font-size: 16px;
    padding: 10px 8px;
    ::v-deep span{
      line-height: 24px;
    }
    &.background_transparent{
      background: transparent;
      color: var(--color-blue-500)!important;
      &.no-border{
        border: none;
        box-shadow: none;
        color: var(--color-grey-500)!important;
        &:hover{
          box-shadow: none!important;
        }
      }
    }
  }
}
</style>
